export default __webpack_public_path__ + "static/media/regulatory--no-caravans--g1.941fa0cc.png";